<section
  class="sky-transition"
  data-testid="sky-transition"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="eyebrow">
  <button
    type="button"
    class="sky-transition-skip"
    data-testid="sky-transition-skip"
    (click)="close()">
    Skip
  </button>

  <div class="sky-transition-content">
    <div class="sky-transition-figure">
      <app-sky-character
        [pose]="state.pose"
        [oneShot]="true"
        (situationComplete)="onSituationComplete()" />
    </div>
    <div class="sky-transition-copy" aria-live="polite">
      <span>{{ eyebrow }}</span>
      <p>{{ state.message }}</p>
    </div>
  </div>
</section>
